<template>
  <modal class="q-modal pwd-update" name="pwd-update-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="500"
       :max-width="500"
       :height="'auto'"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-header">
        {{$t('systemPwd.change')}}
      </div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="modal-container">
            <div class="forminput">{{$t('login.detectedPwd')}}</div>
            <div class="forminput">
              <div class="table">
                <div class="dt-r">
                  <div class="title dt-c">{{$t('systemPwd.newPwd')}}</div>
                  <div class="forminput password dt-c">
                    <input name="Password" v-model="newPassword" class="form-control" :type="showNewPassword" v-validate="'required|password|max:20|min:8'" maxlength="20" size="20" :class="{'error': errors.has('Password') || isDefault}" @keyup.enter="onEnterClick">
                    <span class="div-password-eye icon-view" :class="{'active': showNewPassword==='text'}" @click="onShowNewPasswordClick()">
                    </span>
                    <span v-if="checkEmpty && !isDefault" class="div-password-tick icon-tick"></span>
                  </div>
                </div>
                <div class="dt-r">
                  <div class="dt-c"></div>
                  <div v-show="errors.has('Password') || isDefault" class="errorMessage dt-c">{{(isDefault) ? $t(defaultMsg) : setErrorMsg(errors.first('Password')) }}</div>
                </div>
              </div>
              <div class="table">
                <div class="dt-r">
                  <div class="title dt-c">{{$t('systemPwd.confirmPwd')}}</div>
                  <div class="forminput password dt-c">
                    <input name="Password2" v-model="newPassword2" class="form-control" :type="showNewPassword2" v-validate="'required|password|max:20|min:8'" maxlength="20" size="20" :class="{'error': (errors.has('Password2') || !isMatch) && newPassword2}" @keyup.enter="onEnterClick">
                    <span class="div-password-eye icon-view" :class="{'active': showNewPassword2==='text'}" @click="onShowNewPassword2Click()"></span>
                    <span v-if="checkConsistent" class="div-password-tick icon-tick"></span>
                  </div>
                </div>
                <div class="dt-r">
                  <div class="dt-c"></div>
                  <div v-if="(errors.has('Password2') || !isMatch) && newPassword2" class="errorMessage dt-c">{{(isMatch)? setErrorMsg(errors.first('Password2')) : $t(notMatchMsg) }}</div>
                </div>
              </div>
            </div>
            <div class="forminput"></div>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left" />
        <div class="footer-right">
          <button class="q-button" @click="onSaveClick()" :disabled="isDisabled" :title="$t('ok')">{{$t('ok')}}</button>
        </div>
      </div>
    </div>
    <LogoutWarning :onChange="onLogout" />
    <popup-confirm name="modal-alert" :dialog-header="$t('systemPwd.change')" :dialog-message="$t('systemPwd.changeFail')" selHeight=200 :onlyOk="true" />
  </modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import LogoutWarning from './LogoutWarning'
export default {
  name: 'pwd-update',
  components: {
    LogoutWarning
  },
  data () {
    return {
      modalname: 'pwd-update-modal',
      newPassword: '',
      newPassword2: '',
      showPassword: 'password',
      showNewPassword: 'password',
      showNewPassword2: 'password',
      isDisabled: true,
      // message: [this.$t('systemPwd.info')],
      isMatch: true,
      notMatchMsg: 'systemPwd.notMatch',
      isDefault: false,
      defaultMsg: 'login.defaultMsg'
    }
  },
  created () {
    let me = this
    this.$validator.extend('password', {
      getMessage (field, val) {
        return me.$t('errorMessage.password')
      },
      validate (value, field) {
        // eslint-disable-next-line no-useless-escape
        var temp = /^[A-Za-z\d~!@#$%^&*()_\+\=\-`[\]\\{}|;':",./<>? ]{8,20}$/
        if (!temp.test(value)) {
          return false
        }
        return true
      }
    })
  },
  watch: {
    newPassword: function (value) {
      this.checkValidation()
    },
    newPassword2: function (value) {
      this.checkValidation()
      this.onChange()
    },
    isDisabled: function (value) {
      this.$store.commit('updateDataChanged', !value)
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    onShowPasswordClick: function () {
      this.showPassword === 'password' ? (this.showPassword = 'text') : (this.showPassword = 'password')
    },
    onShowNewPasswordClick: function () {
      this.showNewPassword === 'password' ? (this.showNewPassword = 'text') : (this.showNewPassword = 'password')
    },
    onShowNewPassword2Click: function () {
      this.showNewPassword2 === 'password' ? (this.showNewPassword2 = 'text') : (this.showNewPassword2 = 'password')
    },
    onLogout: async function () {
      this.closeModal('pwd-update-modal')
      this.$modal.hide('pwd-update-modal')
      this.$log.info('logout >>>')
      this.$store.commit('setLoadingType', 'logout')
      this.$store.commit('updateFullLoadingStatus', true)
      await this.postLogout()
    },
    onEnterClick: async function () {
      await this.checkValidation()
      if (!this.isDisabled) {
        this.onSaveClick()
      }
    },
    onSaveClick: function () {
      this.setUserPassword(this.newPassword2)
        .then((res) => {
          if (!res.data.error) {
            this.openModal('logout-modal-alert')
            this.$modal.show('logout-modal-alert')
          }
          this.isDisabled = true
        }).catch((err) => {
          this.$log.error(err)
          this.openModal('modal-alert')
          this.$modal.show('modal-alert')
        })
    },
    checkValidation: function () {
      let mac = (this.sysBoard) ? this.sysBoard.MacAddr.split(':') : ''
      let tempPwd = ''
      for (let idx = 0; idx < mac.length; idx++) {
        tempPwd = tempPwd + mac[idx]
      }
      this.$validator.validateAll().then((result) => {
        if (this.newPassword === tempPwd) {
          this.isDisabled = true
          this.isDefault = true
        } else {
          this.isDefault = false
          if (result) {
            this.onChange()
          } else {
            this.isDisabled = true
          }
        }
      }).catch(() => {
        this.isDisabled = true
      })
    },
    onChange: function () {
      if (this.newPassword !== '' && this.newPassword2 !== '' && this.newPassword === this.newPassword2) {
        this.isMatch = true
        this.isDisabled = false
      } else {
        this.isMatch = false
        this.isDisabled = true
      }
      if (this.newPassword === '' && this.newPassword2 === '') {
        this.isMatch = true
      }
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    setErrorMsg: function (data) {
      let message = data
      if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.isReguired')
        }
      }
      return message
    },
    ...mapActions(['setUserPassword', 'postLogout'])
  },
  computed: {
    ...mapGetters(['getTopModalName']),
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo
    }),
    checkEmpty: function () {
      if (this.$validator.errors.has('Password')) {
        return false
      } else {
        if (this.newPassword !== '') {
          return true
        } else {
          return false
        }
      }
    },
    checkConsistent: function () {
      if (this.isDisabled) {
        return false
      } else {
        if (this.newPassword !== '' && this.newPassword2 !== '' && this.newPassword === this.newPassword2) {
          return true
        } else {
          return false
        }
      }
    },
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../assets/scss/modal.scss';

.pwd-update {
  .q-v--modal {
    .modal-content {
      .forminput {
        margin-bottom: 10px;
        >.table {
          position: relative;
          display: table;
          .title {
            font-size: 13px;
            color: #2F2F2F;
            line-height: 22px;
            font-weight: 500;
            width: 165px;
          }
          .forminput.password {
            position: relative;
            input {
              padding: 0px 25px 0px 10px;
              width: 200px;
              font-size: 13px;
              color: #000000;
              line-height: 30px;
              height: 30px;
              border: 1px solid #979797;
              border-radius: 4px;
            }
            .div-password-eye {
              cursor: pointer;
              color: #7F7F7F;
              position: absolute;
              font-size: 14px;
              top: 8px;
              left: 180px;
              &:hover {
                color: #000000;
              }
              &.active {
                color: #000000;
              }
            }
          }
          .div-password-tick {
            line-height: 30px;
            color: #7ED321;
            background-size: cover;
            position: relative;
            font-size: 13px;
            left: 10px;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ForceUpdatePwd.vue